export const STARTUP_START = 'STARTUP_START'
export const STARTUP_FINISH = 'STARTUP_FINISH'
